import { render, staticRenderFns } from "./back_pack.vue?vue&type=template&id=3ccf627b&scoped=true"
import script from "./back_pack.vue?vue&type=script&lang=ts"
export * from "./back_pack.vue?vue&type=script&lang=ts"
import style0 from "./back_pack.vue?vue&type=style&index=0&id=3ccf627b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf627b",
  null
  
)

export default component.exports